import { createService } from "./serviceFactory";

export const activityService = createService("activities");
